<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="2700"
          :reset="true"
          :custom-search-items="customSearchItems"
          :is-append-query="true"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_QueryTip')"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations" style="display: flex;">
            <el-checkbox
              v-model="autoRefreshCabinList"
              no="12"
              style="margin: 0 5px 0 15px;"
              @change="resetTimer"
            >{{ $t('SeaExport.AutomaticallyRefresh') }}</el-checkbox>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="27000522"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <div :class="'fixedBottom'" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
            <span v-show="selectedRows.length > 0">
              {{ $t('Clearing.Selected') + selectedRows.length + ':' + selectRowDataLabel }}
            </span>
          </div>
          <cargo-pagination
            v-show="!appendQuery && filter.total>0"
            config-module="27000521"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
          <div v-show="appendQuery" class="pagination-container">
            <el-pagination
              style="text-align: left;"
              :total="filter.total"
              layout="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { advancedQueryFunc } from '@/api/booking/cabinManagement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtils from '@/utils/localStorageUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import {
  ALLOCATION_0,
  ALLOCATION_1,
  CABIN_0,
  CABIN_1,
  CABIN_2
} from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'OpenSeaCabinSpace',
  components: {
    searchItem
  },
  data() {
    const autoRefreshCabinList = LocalStorageUtils.getConfiguration('OPEN_SEA_CABIN_SPACE_AUTO_REFRESH') || false
    return {
      isAdvancedQuery: false, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      appendQuery: false, // 追加查询
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      autoRefreshCabinList,
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridOptions.api.getSelectedRows()
        }
      },
      gridParams: {},
      customSearchItems: [],
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceSerialNo'),
          colId: 'allocationSerialNumber',
          field: 'allocationSerialNumber',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SailingDate') + 'ETD',
          colId: 'etd',
          field: 'etd',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          colId: 'shipName',
          field: 'shipName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
          colId: 'voyage',
          field: 'voyage',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_POL'),
          colId: 'departurePort',
          field: 'departurePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
          colId: 'dischargePort',
          field: 'dischargePort',
          width: 150,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CartonQuantity'),
          colId: 'boxTypeQuantity',
          field: 'boxTypeQuantity',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          colId: 'carrierId',
          field: 'carrierId',
          width: 200,
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline'),
          colId: 'regionName',
          field: 'regionName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCode'),
          colId: 'routeCode',
          field: 'routeCode',
          width: 150
        },
        {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationOffice'),
          colId: 'branchId',
          field: 'branchId',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlinePerson'),
          colId: 'routeManager',
          field: 'routeManager',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceNote'),
          colId: 'allocationNote',
          field: 'allocationNote',
          width: 300
        }, {
          headerName: this.$t('CargoMsg.Cargo_GuidedSellingPrice'),
          colId: 'guideSellingPrice',
          field: 'guideSellingPrice',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate'),
          colId: 'cutOffDate',
          field: 'cutOffDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DeclarationCutOffDate'),
          colId: 'declarationDate',
          field: 'declarationDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CYCutOffDate'),
          colId: 'sealingDate',
          field: 'sealingDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffDate2'),
          colId: 'customerSealDate',
          field: 'customerSealDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReturnDateForCustoms'),
          colId: 'customerWithdrawalDate',
          field: 'customerWithdrawalDate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CutOffTime'),
          colId: 'customerCutOffTime',
          field: 'customerCutOffTime',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeDetension'),
          colId: 'freeChestRentPeriod',
          field: 'freeChestRentPeriod',
          width: 150
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_FreeStorageDays'),
          colId: 'freeStackDays',
          field: 'freeStackDays',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CabinSpaceStatus'),
          colId: 'cabinSpaceStatus',
          field: 'cabinSpaceStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.CABIN_LIST)
          }
        }
      ],
      rowData: [],
      selectedRows: []
    }
  },
  computed: {
    selectRowDataLabel() {
      const list = this.selectedRows
      if (list.length > 0) {
        const list0 = list.filter(t => t.allocationStatus === ALLOCATION_0.code)
        const list1 = list.filter(t => t.allocationStatus === ALLOCATION_1.code)
        // 未分配
        const allContainerMap = this.queryContainerData(list0)
        // 已分配
        const selectContainerMap = this.queryContainerData(list1)
        const createLabel = (map) => {
          return Object.keys(map).reduce((acc, key) => {
            const value = map[key]
            acc += `(${value}*${key}) `
            return acc
          }, '')
        }
        let label = ''
        // 勾选的数量
        const selectList = Object.keys(selectContainerMap)
        if (selectList.length > 0) {
          const selectKeyValue = Object.values(selectContainerMap).reduce((acc, value) => acc + Number(value), 0)
          const selectLabel = createLabel(selectContainerMap)
          label = `${this.$t('CargoMsg.Cargo_Allocated')}${selectKeyValue}${selectLabel}`
        }
        // 剩余的数量
        const allList = Object.keys(allContainerMap)
        if (allList.length > 0) {
          const allKeyValue = Object.values(allContainerMap).reduce((acc, value) => acc + Number(value), 0)
          const allLabel = createLabel(allContainerMap)
          label += `${this.$t('CargoMsg.Cargo_NotAllocated')}${allKeyValue}${allLabel}`
        }
        return label
      }
      return ''
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
      this.customSearchItems = this.getCustomSearchItems()
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 初始化页面
    async init() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      // 舱位状态
      const cabinSpaceStatus = SystemConstants.PUBLIC_SEA_CABIN_SPACE_STATUS.map(item => {
        return { code: item.code, chineseName: item.chineseName, englishName: item.englishName }
      })
      let searchField = new AdvancedSearchField()
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cm.CABIN_SPACE_STATUS'
      searchField.itemLabel = 'CargoMsg.Cargo_CabinSpaceStatus'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = cabinSpaceStatus
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.filter.conditions = []
      if (typeof keyword !== 'undefined') {
        const option = new AdvancedSearchOption(null, 'cm.ALLOCATION_SERIAL_NUMBER', keyword.trim(), OperatorConstants.OPERATOR_LIKE.code)
        this.filter.conditions.push(option.formatObj2Json())
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      this.doQueryHandler(this.filter, '')
    },
    handleQueryData(res) {
      let results = res.data.list
      if (this.appendQuery) { // 追加查询数据去重
        results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        this.filter.total = results.length
      } else {
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.pageCount = res.data.pages
      }
      this.rowData = results
      if (this.gridApi) this.gridApi.clearFocusedCell()
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filter.conditions = data
        this.filter.pageNum = 1
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(this.filter.conditions)
      }
      this.filterJson.appendQuery = this.appendQuery
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.doQueryHandler(this.filterJson)
    },
    doQueryHandler(filter) {
      this.fullscreenLoading = getLoading4Cxt()
      const data = filter.conditions
      if (!AdvancedSearchOption.hasField('cm.CABIN_SPACE_STATUS', data)) {
        const option1 = new AdvancedSearchOption('FIELD_MULTI_DROP_DOWN_LIST', 'cm.CABIN_SPACE_STATUS', [CABIN_0.code, CABIN_1.code, CABIN_2.code], AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option1.formatObj2Json())
      }
      const option2 = new AdvancedSearchOption('FIELD_MULTI_DROP_DOWN_LIST', 'cm.ALLOCATION_STATUS', [ALLOCATION_0.code], AdvancedSearchConsts.OPERATOR_IN.code)
      data.push(option2.formatObj2Json())
      filter.conditions = data
      filter.pageSource = 'openSeaCabinSpace'
      advancedQueryFunc(filter).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    closeTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = 0
      }
    },
    resetTimer() {
      LocalStorageUtils.setConfiguration('OPEN_SEA_CABIN_SPACE_AUTO_REFRESH', this.autoRefreshCabinList)
      this.closeTimer()
      if (this.autoRefreshCabinList) {
        this.timerId = setInterval(() => {
          this.toQuery()
        }, 5 * 60 * 1000)
      }
    },
    queryContainerData(list, notList) {
      const map = {}
      for (const data of list) {
        if (data.dataType !== 3) {
          continue
        }
        // 排除一些列表数据
        if (notList) {
          const notData = notList.filter(t => t.uuid === data.uuid)
          if (notData && notData.length > 0) {
            continue
          }
        }
        if (data.boxTypeQuantity) {
          const boxList = data.boxTypeQuantity.split('\n')
          for (const box of boxList) {
            const boxValue = box.split('*')
            const boxQ = map[boxValue[1]] || 0
            map[boxValue[1]] = Number(boxValue[0]) + Number(boxQ)
          }
        }
      }
      return map
    }
  }
}
</script>
